module.exports = __webpack_public_path__ + "img/Sent_messages _Flatline.ab38dd1b.svg";